import Cursor from './Cursor';

export default Cursor;
